module.exports = __webpack_public_path__ + "0ddb7d736bff9ad51b1938ed08525988.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/macha-main-1024.jpg
// module id = 448
// module chunks = 0